export default __webpack_public_path__ + "static/media/SAML_Configuration.1075ee44.png";